module.exports = __webpack_public_path__ + "img/choose-shape-2.82574274.png";